module.exports = __webpack_public_path__ + "media/images/application2/AppUsersTalkHistory__dl__item__top__action__handle-683df54db3a33e8eec848cca987ca973.svg";